const Styles = {
  2: {
    0: {
      style: {
        height: "100%",
        borderRight: "0.5px solid rgba(75, 75, 75, 0.68)"
      },
      size: "160px",
      avatarNamePosition: { left: "102px" }
    },
    1: {
      style: {
        height: "100%",
        borderLeft: "0.5px solid rgba(75, 75, 75, 0.68)"
      },
      size: "160px",
      avatarNamePosition: { left: "50%", transform: "translate(-50%, 0)" }
    }
  },
  3: {
    0: {
      style: {
        height: "100%",
        borderRight: "0.5px solid rgba(75, 75, 75, 0.68)"
      },
      size: "160px",
      avatarNamePosition: { left: "102px" }
    },
    1: {
      style: {
        height: "50%",
        borderLeft: "0.5px solid rgba(75, 75, 75, 0.68)",
        borderBottom: "0.5px solid rgba(75, 75, 75, 0.68)"
      },
      size: "80px",
      avatarNamePosition: { left: "50%", transform: "translate(-50%, 0)" }
    },
    2: {
      style: {
        height: "50%",
        transform: "translate(0px, -100%)",
        borderLeft: "0.5px solid rgba(75, 75, 75, 0.68)",
        borderTop: "0.5px solid rgba(75, 75, 75, 0.68)"
      },
      size: "80px",
      avatarNamePosition: { left: "50%", transform: "translate(-50%, 0)" }
    }
  },
  4: {
    0: {
      style: {
        height: "50%",
        borderRight: "0.5px solid rgba(75, 75, 75, 0.68)",
        borderBottom: "0.5px solid rgba(75, 75, 75, 0.68)"
      },
      size: "80px",
      avatarNamePosition: { left: "102px" }
    },
    1: {
      style: {
        height: "50%",
        borderLeft: "0.5px solid rgba(75, 75, 75, 0.68)",
        borderBottom: "0.5px solid rgba(75, 75, 75, 0.68)"
      },
      size: "80px",
      avatarNamePosition: { left: "50%", transform: "translate(-50%, 0)" }
    },
    2: {
      style: {
        height: "50%",
        borderRight: "0.5px solid rgba(75, 75, 75, 0.68)",
        borderTop: "0.5px solid rgba(75, 75, 75, 0.68)"
      },
      size: "80px",
      avatarNamePosition: { left: "50%", transform: "translate(-50%, 0)" }
    },
    3: {
      style: {
        height: "50%",
        borderLeft: "0.5px solid rgba(75, 75, 75, 0.68)",
        borderTop: "0.5px solid rgba(75, 75, 75, 0.68)"
      },
      size: "80px",
      avatarNamePosition: { left: "50%", transform: "translate(-50%, 0)" }
    }
  }
};

export { Styles };
